import React from "react";

export const ComputadorIcon = ({
  size = "32",
  className,
}: {
  size?: string;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      height={size}
      width={size}
      className={className}
    >
      <path d="m497 422h-5v-115c0-19.299-15.701-35-35-35h-46v-123.58c17.459-6.192 30-22.865 30-42.42 0-24.813-20.187-45-45-45-19.555 0-36.228 12.541-42.42 30h-83.58v-56c0-19.299-15.701-35-35-35h-180c-19.299 0-35 15.701-35 35v115h-5c-8.284 0-15 6.716-15 15v10c0 35.841 29.159 65 65 65h36v93.58c-17.459 6.192-30 22.865-30 42.42 0 24.813 20.187 45 45 45 19.555 0 36.228-12.541 42.42-30h83.58v31h-5c-8.284 0-15 6.716-15 15v10c0 35.841 29.159 65 65 65h160c35.841 0 65-29.159 65-65v-10c0-8.284-6.716-15-15-15zm-101-331c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15zm-346-56c0-2.757 2.243-5 5-5h180c2.757 0 5 2.243 5 5v115h-190zm-19.644 145h229.288c-2.434 16.939-17.042 30-34.644 30h-160c-17.602 0-32.21-13.061-34.644-30zm85.644 211c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zm42.42-30c-4.527-12.764-14.656-22.893-27.42-27.42v-93.58h94c35.841 0 65-29.159 65-65v-10c0-8.284-6.716-15-15-15h-5v-29h83.58c4.527 12.764 14.656 22.893 27.42 27.42v123.58h-104c-19.299 0-35 15.701-35 35v54zm113.58-54c0-2.757 2.243-5 5-5h180c2.757 0 5 2.243 5 5v115h-190zm175 175h-160c-17.602 0-32.21-13.061-34.644-30h229.288c-2.434 16.939-17.042 30-34.644 30z" />
    </svg>
  );
};
